
import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { NotificationSummary } from "@/components/notifications/NotificationSummary";
import QuickActions from "@/components/dashboard/QuickActions";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { getIconComponent } from "./icons/StatsIcons";

interface SidebarSectionProps {
  showBackButton?: boolean;
}

const SidebarSection = ({ showBackButton = false }: SidebarSectionProps) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate back to previous page
  };

  return (
    <motion.div 
      className="space-y-6"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      {showBackButton && (
        <Button 
          variant="outline" 
          size="sm" 
          className="mb-4 w-full flex items-center justify-center"
          onClick={handleGoBack}
        >
          {getIconComponent("ArrowLeft")}
          <span className="ml-2">Back to Dashboard</span>
        </Button>
      )}
      
      {/* Notifications Summary */}
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-0 overflow-hidden">
        <NotificationSummary />
      </div>
      
      {/* Quick Actions */}
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-0 overflow-hidden">
        <QuickActions />
      </div>
    </motion.div>
  );
};

export default SidebarSection;
